import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from './Avatar';
import { Alert, Container, Row } from 'react-bootstrap';
import { StyledDiv, StyledCol, StyledLink, LogOutButton, H1, H4, CustomAlertHeading } from './styled';
import { useInfoTiers, useTiers } from '../../hooks/useTier';
import { useHomepage } from '../../hooks/useUser'
import { theme } from '../../theme/theme';
import { LinkLogo } from './LinkLogo';
import { useExistantProducts, useEmailUser } from '../../hooks/useUser';
import { useConditionallyFinish } from '../../hooks/useConditionallyFinish';

/**
 * Component with homepage
 * @component
 * @returns
 */
export const Homepage = () => {
  const { t } = useTranslation();
  const {
    code,
    expiredFiles,
    level,
    onLogout,
    rejectedFiles,
    routeExpired,
    routeProducts,
    routeProfile,
    routeRejected,
    username,
    routeRequests,
    routeCreatedProducts,
    isProcessingDocuments
  } = useHomepage();
  useTiers();
  const { seventh } = theme;
  const { lastTier } = useInfoTiers();
  const [show, setShow] = useState(true);
  const { clientProducts } = useExistantProducts();
  const { email } = useEmailUser() 
  const { isConditionallyFinished } = useConditionallyFinish()

  return (
    <StyledDiv>
      <LinkLogo />
      <LogOutButton onClick={ onLogout } name="link_logout">
        <h5>{ t("homepage.logout") }</h5>
      </LogOutButton>
      <Container>
        <Row>
          <StyledCol xs={12}>
            <Avatar 
              margin='20px'
            />
          </StyledCol>
          <StyledCol xs={12}>
              <H1 className="mb-2">{ t("homepage.greeting", { username: username || email[0]?.text }) }</H1>
            <H4 className="mb-2">
              { t("homepage.code") }&nbsp;<strong>{ code }</strong>
            </H4>
            <H4 className="mb-1">
              { t("homepage.profile") }&nbsp;
              <StyledLink
                className="p-0"
                onClick={ routeProfile }
                color="first"
                xs={12}
                name="link_profile"
              >
                { t("profile.name") }
              </StyledLink>
            </H4>
            <H4 className="mb-1">
              { t("homepage.about") }&nbsp;
              <StyledLink
                className="p-0"
                onClick={ routeProducts }
                color="first"
                xs={12}
                name="link_products"
              >
                { t("common.productsServices") }
              </StyledLink>
            </H4>
            <H4 className="mb-1">
              <StyledLink
                className="p-0"
                onClick={ routeRequests }
                color="first"
                xs={12}
                name="link_products_request"
              >
                { t("common.productRequest") }
              </StyledLink>
            </H4>
            {
              (clientProducts?.length > 0) && (
              <H4 className="mb-1">
                <StyledLink
                  className="p-0"
                  onClick={ routeCreatedProducts }
                  color="first"
                  xs={12}
                  name=""
                >
                  { t("block.edition") }
                </StyledLink>
              </H4>)
            }
            {(rejectedFiles && !isProcessingDocuments) && (
              <Alert
                variant='danger'
              >
                <CustomAlertHeading>
                  { t("common.rejectedFilesTitle") }
                </CustomAlertHeading>
                <StyledLink
                  className="p-0"
                  onClick={ routeRejected }
                  color="seventh"
                  xs={12}
                  name="link_rejected_files"
                >
                  <p className="p-0 m-0">
                    { t("common.rejectedFiles") }
                  </p>
                </StyledLink>
              </Alert>
            )}
            {expiredFiles && (
              <StyledLink
                className="p-0"
                onClick={ routeExpired }
                color="third"
                xs={12}
                name="link_expired_files"
              >
                <p className="p-0 m-0" style={{ color: seventh }}>
                  { t("common.expiredFiles") }
                </p>
              </StyledLink>
            )}
          </StyledCol>
          {(show && parseInt(level) === parseInt(0)) && (
            <StyledCol xs={12} className="mt-1">
              <Alert
                key="info"
                dismissible
                variant="info"
                onClose={() => setShow(false)}
              >
                { t("homepage.startLevel") }
              </Alert>
            </StyledCol>
          )}
          {(show && parseInt(level) !== parseInt(0) && parseInt(
            level) < parseInt(lastTier?.verification_level)) && 
              !isConditionallyFinished && (
                <StyledCol xs={12} className="mt-1">
                  <Alert
                    key="warning"
                    dismissible
                    variant="warning"
                    onClose={() => setShow(false)}
                  >
                    { t("homepage.finishLevel") }
                  </Alert>
                </StyledCol>
          )}
        </Row>
      </Container>
    </StyledDiv>
  );
};